var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2726_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2124 4.5H12.7124V3.3375C12.7124 2.925 12.3749 1.125 11.9624 1.125C11.5499 1.125 11.2124 2.925 11.2124 3.3375V4.5H3.7124C3.0749 4.5 2.5874 4.9875 2.5874 5.5875C2.5874 6.1875 3.0749 6.675 3.7124 6.675C4.3499 6.675 4.8374 6.1875 4.8374 5.5875C4.8374 5.5125 8.0249 7.0125 11.1749 7.0875V19.2375C9.4124 19.3125 8.0624 19.95 8.0624 20.4375C8.0624 20.5125 8.0999 20.625 8.1749 20.7H6.7499C6.4499 20.7 6.2249 20.925 6.2249 21.1875V22.3875C6.2249 22.65 6.4499 22.875 6.7499 22.875H8.2874C8.5874 22.875 8.8124 22.65 8.8124 22.3875V22.125H14.9624V22.3875C14.9624 22.65 15.1874 22.875 15.4874 22.875H17.0249C17.3249 22.875 17.5499 22.65 17.5499 22.3875V21.1875C17.5499 20.925 17.3249 20.7 17.0249 20.7H15.5999C15.6749 20.625 15.7124 20.55 15.7124 20.4375C15.7124 19.95 14.3624 19.3125 12.5999 19.2375V7.0875C15.7874 7.05 18.9374 5.55 18.9374 5.5875C18.9374 6.1875 19.4249 6.675 20.0624 6.675C20.6999 6.675 21.1874 6.1875 21.1874 5.5875C21.3374 4.9875 20.8499 4.5 20.2124 4.5Z",
    stroke: "#1F3549",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.412598 16.5L3.7501 6.71252L7.1251 16.8375",
    stroke: "#1F3549",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.875L20.2125 6.71252L23.625 17.2125",
    stroke: "#1F3549",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 16.65C7.125 17.3625 5.625 18 3.75 18C1.875 18 0.375 17.3625 0.375 16.65C0.375 15.9375 7.125 15.9375 7.125 16.65Z",
    stroke: "#1F3549",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5874 17.025C23.5874 17.7375 22.0874 18.375 20.2124 18.375C18.3374 18.375 16.8374 17.7375 16.8374 17.025C16.8749 16.3125 23.5874 16.3125 23.5874 17.025Z",
    stroke: "#1F3549",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2726_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/integrity.d06c661c0251bc37280d67b973aaddc1.svg";
export { ForwardRef as ReactComponent };